import { Link } from 'react-router-dom';
import type { getIncompleteRequiredSubsections } from '../../utils/config-utils';

type Props = {
  sections: ReturnType<typeof getIncompleteRequiredSubsections>;
  tenant?: string;
  formId?: string;
};

export default function IncompleteSections({ sections, tenant, formId }: Props) {
  if (!sections.length) return null;
  const base = tenant ? `/${tenant}` : '';
  const search = formId ? `?formId=${encodeURIComponent(formId)}` : '';
  return (
    <div className="govuk-!-margin-top-4">
      <p className="govuk-body-s">The below sections are incomplete</p>
      <ul className="govuk-list govuk-!-font-size-16">
        {sections.map(({ section, subsection }) => (
          <li key={`${section.slug}/${subsection.slug}`}>
            {subsection.title}{' '}
            <Link className="govuk-link" to={`${base}/${section.slug}/${subsection.slug}${search}`}>
              Go to section<span className="govuk-visually-hidden"> for {subsection.title}</span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
